import React, { Component } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
const TIMER = 1500,
    MESSAGE_SIZE = 1000;

import CommonFetch from '../../requests/commonFetch'

export default class switchWallet extends Component {
    constructor(props) {
        super(props)

        this.state = {
            copied: false,
            textCopyBtn: 'Copy',
            value: '',
            correctedString: '',
            modal: false,
            dataForm: '',
            errorMessage: 'operation failed',
            successMessage: 'operation completed successfully',
            activeError: false,
            activeSuccess: false,
            timeout: 2000,
            commission: '',
            commissionError: false,
            commissionProcess: false,
            twofaType: false,
            twofaText: '',
        }

        this.twoFAText = {
            'none': '',
            'email': 'sent to Email',
            'sms': 'sent by SMS',
            'ga': 'from the Google Authenticator app',
        }

        this.timer = '';
        this.coin = '';
        this.translation = JSON.parse(localStorage.translation)[localStorage.language];
    }

    componentDidMount() {
        this.checkTwoFAType();
    }

    checkTwoFAType = () => {
        CommonFetch({
            path: 'ui/investor_settings/get_userdata',
            method: 'GET',
        }).then(data => {
            if (data['2fa_type'] !== 'none') {
                this.setState({
                    twofaType: true,
                    twofaText: this.translation[this.twoFAText[data['2fa_type']]],
                })
            } else if (data.error === 'not_logged_in') {
                this.props.exitOverdueSession()
            }
        })
    }

    defineCoin = () => {
        if (this.props.currentWallet.blockchain === this.props.currentWallet.currency)
            this.coin = 'coin';
        else if (this.props.currentWallet.blockchain === 'ETH')
            this.coin = 'token';
        else if (this.props.currentWallet.blockchain === 'NEM')
            this.coin = 'mosaic';
    }

    resetForm = () => {
        if (this.props.currentWallet.can_be_sent) {
            let form = document.querySelector('.switchWalletRight').querySelector('form'),
                button = form.querySelector('input[type=submit]');

            button.disabled = true;
            form.reset();
            this.setState({
                value: '',
                commission: '',
            })
        }
    }

    checkPossibilityOfPaymentTransaction = (feeCurrency, currency, feeAmount, amount) => {
        let valid = true;

        if (feeCurrency === currency) {
            let sumAmount = (+feeAmount) + (+amount),
                wallets = this.props.data.wallets;
            for (let i in wallets) {
                if (wallets[i].blockchain === this.props.currentWallet.blockchain &&
                    wallets[i].currency === this.props.currentWallet.currency) {
                    sumAmount < wallets[i].balance ? valid = true : valid = false;
                    break;
                }
            }
        } else {
            let wallets = this.props.data.wallets;
            if (+amount < +this.props.currentWallet.balance) {
                for (let i in wallets) {
                    if (wallets[i].blockchain === this.props.currentWallet.blockchain &&
                        wallets[i].currency === feeCurrency) {
                        (+feeAmount) < (+wallets[i].balance) ? valid = true : valid = false;
                        break;
                    }
                }
            } else {
                valid = false;
            }
        }

        return valid;
    }

    checkAddress = (address) => {
        let re = new RegExp(this.props.currentWallet.receiver_regexp);
        return re.test(address);
    }

    handleChange = event => {
        let string = event.target.value.replace(/[^0-9,.]/g, '')
        string = string.replace(/,/g, '.')
        string = string.replace(/^([^\.]*\.)|\./g, '$1')

        let correctedString = (+string)
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')

        this.setState({
            value: string,
            correctedString,
        })
    }

    formSubmit = event => {
        event.preventDefault();

        let form = event.target;
        let dataForm = new FormData(form);
        this.setState({
            dataForm: dataForm,
        })

        this.getStatus();
    }

    getStatus = () => {
        if (this.state.twofaType) {
            CommonFetch({
                path: 'ui/get_status',
                method: 'GET',
            }).then(data => {
                if (data.error === 'not_logged_in') {
                    this.props.exitOverdueSession()
                } else if (data['2fa_code_request_required']) {
                    this.get2FACode()
                } else if (!data['2fa_code_request_required']) {
                    this.setState({
                        modal: true,
                    })
                }
            })
        } else {
            this.setState({
                activeError: true,
                errorMessage: 'need to configure two-factor authentication',
            })
            this.messageClose()
        }
    }

    postSend = event => {
        event.preventDefault()
        let btnSubmit = event.target.querySelector('input[type=submit]')
        let dataForm = this.state.dataForm
        btnSubmit.setAttribute('disabled', 'true')

        dataForm.append(
            '2fa_code',
            event.target.querySelector('input[type=text]').value
        )
        dataForm.append('currency', this.props.currentWallet.currency)
        dataForm.append('blockchain', this.props.currentWallet.blockchain)

        CommonFetch({
            path: 'ui/wallet/post_send',
            method: 'POST',
            data: dataForm,
        }).then(data => {
            if (data.success) {
                this.modalClose()
                this.setState({
                    activeSuccess: true,
                })
                this.messageClose()
            } else if (data.error === 'not_logged_in') {
                this.props.exitOverdueSession()
            } else {
                this.setState({
                    activeError: true,
                    errorMessage: 'operation failed',
                })
                this.messageClose()
            }
            btnSubmit.setAttribute('disabled', 'false')
        })
    }


    get2FACode = () => {
        CommonFetch({
            path: 'ui/auth/post_request2facode',
            method: 'POST',
        }).then(data => {
            if (data.success) {
                this.setState({
                    modal: true,
                })
            } else if (data.error === 'not_logged_in') {
                this.props.exitOverdueSession()
            }
        })
    }


    modalView = () => {
        return (
            <div className="modal">
                <div className="background" onClick={this.modalClose} ></div>
                <div className="modal-content">
                    <form onSubmit={this.postSend}>
                        <h4>{`${this.translation['Enter two-factor']}${this.state.twofaText}`}</h4>
                        <input name="2fa_code" type="text" />
                        <input type="submit" className="btn btn-submit" value={this.translation['Send']} />
                    </form>
                </div>
            </div>
        )
    }

    modalClose = () => {
        this.setState({
            modal: false,
            dataForm: '',
        })
    }

    errorMessageView = () => {
        return (
            <div className={`error_message ${this.state.activeError ? 'active' : ''}`}>
                <p>{this.translation[this.state.errorMessage]}</p>
            </div>
        )
    }

    successMessageView = () => {
        return (
            <div className={`success_message ${this.state.activeSuccess ? 'active' : ''}`}>
                <p>{this.translation[this.state.successMessage]}</p>
            </div>
        )
    }

    messageClose = () => {
        setTimeout(() => this.setState({
            activeError: false,
            activeSuccess: false,
        }), this.state.timeout);
    }

    countOfCommission = () => {
        clearTimeout(this.timer);
        let {currency, blockchain} = this.props.currentWallet
        let form = document.querySelector('.switchWalletRight').querySelector('form'),
            button = form.querySelector('input[type=submit]'),
            amount = form.querySelector('input[name=amount]').value,
            message = '';

        if (this.props.currentWallet.message_field)
            message = form.querySelector('input[name=message]').value;
        else
            message = '';

        this.timer = setTimeout(() => {
                CommonFetch({
                    path: `ui/wallet/get_fee?
                            currency=${currency}&
                            blockchain=${blockchain}&
                            amount=${amount}&
                            receiver=${
                                form.querySelector('input[name=receiver]').value
                            }&
                            message=${message}`,
                    method: 'GET',
                }).then(data => {
                        if (data.success && data.fee_amount) {
                            let commission = '';
                            if (this.checkPossibilityOfPaymentTransaction(data.fee_currency, this.props.currentWallet.currency, data.fee_amount, amount)) {
                                commission = this.translation['The cost per transaction'] + ' ' + data.fee_amount + ' ' + data.fee_currency;
                            } else {
                                commission = this.translation['Not enough money to pay commission'];
                            }
                            this.setState({
                                commission: commission,
                                commissionError: !this.checkPossibilityOfPaymentTransaction(data.fee_currency, this.props.currentWallet.currency, data.fee_amount, amount),
                                commissionProcess: false,
                            })
                        } else if (data.error === 'not_logged_in') {
                            this.props.exitOverdueSession();
                        } else if (!data.success) {
                            let commission = this.translation['Commission calculation error'];
                            this.setState({
                                commission: commission,
                                commissionError: true,
                                commissionProcess: false,
                            })
                        }
                        button.disabled = !this.checkPossibilityOfPaymentTransaction(data.fee_currency, this.props.currentWallet.currency, data.fee_amount, amount);
                    });
            },
            TIMER)
    }

    validForm = () => {
        let form = document.querySelector('.switchWalletRight form'),
            button = form.querySelector('input[type=submit]'),
            address = form.querySelector('input[name=receiver]').value,
            message = this.props.currentWallet.message_field ? form.querySelector('input[name=message]').value : '',
            amount = form.querySelector('input[name=amount]').value,
            messageSize = new Blob([message]).size;

        let commission = '';
        // if (address === '' || amount === '' || (this.props.currentWallet.message_field && message === '')) {
        if (address === '' || amount === '') {
            clearTimeout(this.timer);
            button.disabled = true;
            this.setState({
                commission: commission,
                commissionError: false,
                commissionProcess: false,
            })
            return;
        } else if (!this.checkAddress(address)) {
            commission = this.translation['Enter the correct address'];
        } else if (amount <= 0) {
            commission = this.translation['Enter an amount greater than 0'];
        } else if (!message && messageSize > MESSAGE_SIZE) {
            commission = this.translation['Message size exceeds maximum size'];
        } else {
            this.setState({
                commission: '',
                commissionProcess: true,
            })
            this.countOfCommission();
            return;
        }

        button.disabled = true;
        this.setState({
            commission: commission,
            commissionError: true,
            commissionProcess: false,
        })
    }

    copyAddress = () => {
        this.setState({
            copied: true,
            textCopyBtn: 'Copied',
        })
        setTimeout(() => this.setState({ textCopyBtn: 'Copy' }), 1000)
    }

    render() {
        this.defineCoin();

        return (
            <div className="switchWalletRight">
                <div className="switchWalletRight_top">
                    <p>{`${this.translation['To receive a transfer']}
                        ${this.translation[
                            this.coin === 'coin' ? 'coin' :
                            this.coin === 'token' ? 'token' : 'mosaic'
                        ]}
                        ${this.props.activeTab}
                        ${this.translation[
                            this.coin === 'coin' ? 'coins can be sent to it' :
                            this.coin === 'token' ? 'tokens can be sent to it' : 'mosaics can be sent to it'
                        ]}`}</p>
                </div>
                <div className="switchWalletRight_middle">
                    <input value={this.props.currentWallet.address} readOnly />
                    <CopyToClipboard
                        text={this.props.currentWallet.address}
                        onCopy={this.copyAddress}
                    >
                        <span>{this.translation[this.state.textCopyBtn]}</span>
                    </CopyToClipboard>
                </div>
                <div className="switchWalletRight_link_blockchain">
                    {this.props.currentWallet.blockchain === 'NEM' ?
                        <a href={`http://explorer.nemchina.com/#/s_account?account=${this.props.currentWallet.address}`} target="_blank">explorer.nemchina.com</a> :
                        <a href={`https://etherscan.io/address/${this.props.currentWallet.address}`} target="_blank">etherscan.com</a> }
                </div>
                {this.props.currentWallet.can_be_sent ?
                    <form
                        className="switchWalletRight_form"
                        onSubmit={this.formSubmit}
                        onChange={this.validForm}
                    >
                        <div className="switchWalletRight_form_info_address">
                            <p>{`${this.translation['To send put']}
                                ${this.translation[
                                    this.coin === 'coin' ? 'coin' :
                                    this.coin === 'token' ? 'token' : 'mosaic'
                                ]}
                                ${this.props.activeTab}${this.translation[
                                    this.coin === 'coin' ? 'coins enter' :
                                    this.coin === 'token' ? 'tokens enter' : 'mosaics enter'
                                ]}
                                ${this.translation['wallet address or name']}`}</p>
                        </div>
                        <div className="switchWalletRight_form_wallet_address">
                            <input
                                type="text"
                                placeholder={`Ex: ${this.props.currentWallet.address}`}
                                name="receiver"
                            />
                        </div>
                        <div className="switchWalletRight_form_info_how_much">
                            <p>{`${this.translation['How much send']}
                                ${this.translation[
                                    this.coin === 'coin' ? 'coins' :
                                    this.coin === 'token' ? 'tokens' : 'mosaics'
                                ]}
                                ${this.props.activeTab}
                                ${this.translation[
                                    this.coin === 'coin' ? 'coins to be sent' :
                                    this.coin === 'token' ? 'tokens to be sent' : 'mosaics to be sent'
                                ]}`}</p>
                        </div>
                        <div className="switchWalletRight_form_transfer_amount">
                            <input
                                type="text"
                                placeholder="0,0"
                                required
                                value={this.state.value}
                                onChange={this.handleChange}
                                name="amount"
                            />
                            <p>{this.props.activeTab}</p>
                        </div>
                        {this.props.currentWallet.message_field ?
                            <div className="switchWalletRight_form_info_message">
                                <p>{this.translation['Message']}</p>
                            </div> : null}
                        {this.props.currentWallet.message_field ?
                            <div className="switchWalletRight_form_wallet_message">
                                <input
                                    type="text"
                                    name="message"
                                />
                            </div> : null}
                        <div className="switchWalletRight_form_info_commission">
                            <div>
                                {this.state.commission ?
                                    <p className={this.state.commissionError ? 'error' : ''}>{this.state.commission}</p> :
                                    null}
                                {this.state.commissionProcess ?
                                    this.preloader() :
                                    null}
                            </div>
                            {this.state.dataForm ?
                                this.preloader() :
                                <input type="submit" value={this.translation['Send']} disabled />
                            }
                        </div>
                    </form> :
                null }
                {this.state.modal ? this.modalView() : ''}
                {this.errorMessageView()}
                {this.successMessageView()}
            </div>
        );
    }

    preloader = () => {
        return(
            <div className="preloader">
                <div></div>
                <div></div>
            </div>
        )
    }
}
